<template>
  <v-card>
    <v-card-title class="headline justify-center grey lighten-2">{{
      title
    }}</v-card-title>
    <v-col class="center" cols="6">
      <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "loader-dialog-template",
  props: {
    title: {
      type: String,
      defualt: "",
    },
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>